import ActivityBasedTimer from '@/services/activityBasedTimer'
import ky from 'ky'
import store from '@/store'

const alertTimer = ActivityBasedTimer()

export const fetchWarningMessage = async () => {
  return ky.get('/configuration/config.json')
    .then(response => response.json())
    .then(config => {
      if (config && (config.alert || config.alert === '')) {
        store.commit('app/SET_ALERT_MESSAGE', config.alert)
      }
    })
}

alertTimer.setInterval({
  async callback () {
    await fetchWarningMessage()
  },
  // Normal interval is once every 10 minutes
  // interval: 1000 * 60 * 10,
  interval: 1000 * 10,
  // Forced interval is once per day
  forcedInterval: 1000 * 60 * 60 * 24
})

export default alertTimer
